<template>
  <div
    data-component-group="form"
    data-component="edit-payment"
    class="elevation-1"
  >
    <PaymentForm
      :payment="payment"
      confirm-trigger-label="Update payment"
      :is-disabled="true"
      :is-loading="isLoading"
      :on-submit="onSubmit"
    />

    <PaymentAmountForm
      :payment="payment"
      confirm-trigger-label="Update amount"
      :is-disabled="!canEditAmount"
      :is-loading="isLoading"
      :on-submit="isOpened ? onSubmit : undefined"
    >
      <template v-slot:beforeForm>
        <layout-section-header
          title="Amount"
          :has-trigger="isOpened"
          :trigger-label="amountLabel"
          @toggle="toggleEditAmount"
        />
      </template>
    </PaymentAmountForm>
  </div>
</template>

<script>
  import PaymentForm from './AddNew';
  import PaymentAmountForm from './Amount';
  import { isObj } from '../../../utils';

  export default {
    components: {
      PaymentForm,
      PaymentAmountForm,
    },
    props: {
      payment: {
        type: Object,
        required: true,
      },
      isLoading: {
        type: Boolean,
        default: false,
      },
      onCancel: {
        type: Function,
        default: undefined,
      },
      onSubmit: {
        type: Function,
        default: undefined,
      },
    },
    data() {
      return {
        canEditAmount: false,
        isUpdatingDiscount: false,
      };
    },
    computed: {
      amountLabel() {
        return !this.canEditAmount ? 'Edit amount' : 'Close';
      },
      isOpened() {
        const { payment = {} } = this;
        const { name = '' } = payment.status || {};
        return name.toLowerCase() === 'open';
      },
    },
    watch: {
      payment(nextPayment) {
        if (isObj(nextPayment)) {
          this.canEditAmount = false;
        }
      },
    },
    methods: {
      toggleEditAmount() {
        this.canEditAmount = !this.canEditAmount;
      },
    },
  };
</script>
